import {createUseStyles} from "react-jss";

export const useStyles = createUseStyles({
    promoBanner: {
        backgroundColor: "#6049EB",
        border: "2px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0px 0px 14px rgba(0, 0, 0, 0.25)",
        borderRadius: 8,
        paddingTop: 17,
        paddingRight: 40,
        paddingBottom: 17,
        paddingLeft: 24,
        display: "flex",
        alignItems: "center",
        position: "relative",
        zIndex: 1,
        "@media (max-width: 1200px)": {
            flexDirection: "column",
            padding: 24,
            textAlign: "center"
        }
    },
    promoBannerVideoPreview: {
        width: 263,
        height: 145,
        borderRadius: 5,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
        "&:before": {
            content: "''",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: "auto",
            background: "linear-gradient(180.6deg, rgba(0, 0, 0, 0.12) 0.52%, #000000 108.5%)",
            borderRadius: 5
        },
        "&:hover": {
            "& $promoBannerVideoThumbnailText": {
                "&:before": {
                    transform: "scale(1.2)"
                }
            }
        },
        "@media (max-width: 1200px)": {
            width: "100%",
            height: 154
        }
    },
    withVideo: {
        cursor: "pointer"
    },
    promoBannerVideoThumbnail: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 5,
    },
    promoBannerVideoThumbnailText: {
        position: "absolute",
        fontSize: 18,
        fontWeight: 600,
        color: "#FFFFFF",
        "&:before": {
            content: "''",
            width: 49,
            height: 48,
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 8,
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='49' height='48' viewBox='0 0 49 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='24.7129' cy='24' r='24' fill='%2365C15D'/%3E%3Cpath d='M31.7057 21.8566C33.3761 22.7972 33.3761 25.2024 31.7057 26.143L23.4909 30.7687C21.8513 31.692 19.8245 30.5072 19.8245 28.6255L19.8245 19.3741C19.8245 17.4924 21.8513 16.3076 23.4909 17.2309L31.7057 21.8566Z' fill='white'/%3E%3C/svg%3E%0A\")",
            backgroundSize: "cover",
            transition: "transform .2s"
        }
    },
    promoBannerText: {
        marginLeft: 24,
        flexGrow: 1,
        color: "#FFFFFF",
        "@media (max-width: 1200px)": {
            order: -1,
            marginLeft: 0,
            marginBottom: 16
        },
        "@media (max-width: 600px)": {
            fontSize: "18px !important",
            lineHeight: "1.75 !important"
        }
    },
    promoButton: {
        flexShrink: 0,
        "& a, button": {
            minWidth: 160,
            "@media (max-width: 600px)": {
                width: "100%"
            }
        },
        "@media (max-width: 1200px)": {
            marginTop: 32
        },
        "@media (max-width: 600px)": {
            width: "100%"
        }
    },
    promoBannerModal: {
        backgroundColor: "transparent !important",
        fontSize: 0,
        maxWidth: 1072,
        margin: "auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "none !important",
        marginTop: 48,
        marginBottom: 48,
        position: "relative",
        "@media (max-width: 1200px)": {
            marginLeft: 32,
            marginRight: 32
        },
        "@media (max-width: 600px)": {
            marginLeft: 16,
            marginRight: 16,
            marginTop: 0,
            marginBottom: 0
        },
        "& .modalCloseBtn": {
            top: "-28px !important",
            right: "-28px !important",
            "@media (max-width: 1200px)": {
                top: "-42px !important",
                right: "0 !important"
            },
            "@media (max-width: 600px)": {
                top: "12px !important",
                right: "0px !important"
            }
        }
    },
    promoBannerVideo: {
        width: "100%",
        height: 700,
        "@media (max-width: 600px)": {
            height: 340
        }
    },
    promoBannerModalBtn: {
        marginTop: 16,
        minWidth: 250,
        "@media (max-width: 600px)": {
            width: "100%"
        }
    }
});
